import { Button, Card, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getDataDuAnVKT,
  getDataPhuong,
  getDataQuan,
} from '../../../../redux/actions/search.action';

class SearchKienTruc extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuAnVKT: this.props.listDuAnVKT,

      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.listQuan !== this.props.listQuan) {
      this.setState({ listQuan: this.props.listQuan });
    }

    if (prevProps.listPhuong !== this.props.listPhuong) {
      this.setState({ listPhuong: this.props.listPhuong });
    }

    if (prevProps.listDuAnVKT !== this.props.listDuAnVKT) {
      this.setState({ listDuAnVKT: this.props.listDuAnVKT });
    }
  }

  onChangeQuan(value) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan === value);

    let listDuAnVKT = this.props.listDuAnVKT.filter((e) => e.IDHuyen === value);

    this.setState({
      selectedQuan: value,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
      listPhuong: listPhuong,
      listDuAnVKT: listDuAnVKT,
    });
  }

  async componentDidMount() {
    if (this.props.listDuAnVKT.length === 0) await this.props.getDataDuAnVKT();
  }

  onChangePhuong(value, option) {
    let listPhuong = this.props.listPhuong.slice();
    listPhuong = listPhuong.filter((e) => e.MaQuan === option.IDQuan);
    let selectedQuan = this.state.listQuan.filter(
      (e) => e.MAHUYEN === option.IDQuan
    );
    let listDuAnVKT = this.props.listDuAnVKT.filter(
      (e) => e.Maphuong === value
    );
    this.setState({
      selectedQuan:
        selectedQuan && selectedQuan.length !== 0
          ? selectedQuan[0].MAHUYEN
          : undefined,
      selectedPhuong: value,
      selectedDuAn: undefined,
      listPhuong: listPhuong,
      listDuAnVKT: listDuAnVKT,
    });
  }

  onChangeDuAn(value, option) {
    let selectedPhuong = option.idphuong;
    let selectedQuan = option.idquan !== null ? `${option.idquan}` : undefined;

    this.setState({
      selectedDuAn: value,
      selectedPhuong: selectedPhuong,
      selectedQuan: selectedQuan,
    });
  }

  onResetButton() {
    this.setState({
      listQuan: this.props.listQuan,
      listPhuong: this.props.listPhuong,
      listDuAnVKT: this.props.listDuAnVKT,
      selectedQuan: undefined,
      selectedPhuong: undefined,
      selectedDuAn: undefined,
    });
  }

  onSearch() {
    let data = {
      selectedQuan: this.state.selectedQuan,
      selectedPhuong: this.state.selectedPhuong,
      selectedDuAn: this.state.selectedDuAn,
    };

    this.props.onSearchVKT(data);
  }

  render() {
    return (
      <div className='popup-search' style={{ zIndex: 12 }}>
        <div className='title font-size-16'>
          Tìm kiếm thông tin
          <i
            className='fas fa-times icon-close'
            onClick={() => {
              this.props.close();
            }}
          ></i>
        </div>

        <Card title='Kiến trúc' size='small'>
          <div className='body'>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%',
              }}
            >
              <div>
                <div className='group'>
                  <div className='gr-title'>
                    <div className='text'>Quận/Huyện</div>
                  </div>

                  <div className='gr-body'>
                    <Select
                      className='select'
                      showSearch
                      value={this.state.selectedQuan}
                      onChange={(value) => this.onChangeQuan(value)}
                      optionFilterProp='name'
                    >
                      {this.state.listQuan.map((e, i) => (
                        <Select.Option
                          value={e.MAHUYEN}
                          key={i}
                          name={e.TENHUYEN}
                        >
                          {e.TENHUYEN}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>

                <div className='group'>
                  <div className='gr-title'>
                    <div className='text'>Phường/Xã</div>
                  </div>

                  <div className='gr-body'>
                    <Select
                      className='select'
                      showSearch
                      onChange={(value, option) =>
                        this.onChangePhuong(value, option)
                      }
                      value={this.state.selectedPhuong}
                      optionFilterProp='name'
                    >
                      {this.state.listPhuong.map((e, i) => (
                        <Select.Option
                          value={e.MaPhuong}
                          IDQuan={e.MaQuan}
                          key={i}
                          name={e.TenPhuong}
                        >
                          {e.TenPhuong}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>

                <div className='group'>
                  <div className='gr-title'>
                    <div className='required'>*</div>
                    <div className='text'>Tên khu vực</div>
                  </div>

                  <div className='gr-body'>
                    <Select
                      className='select'
                      showSearch
                      onChange={(value, option) =>
                        this.onChangeDuAn(value, option)
                      }
                      value={this.state.selectedDuAn}
                    >
                      {this.state.listDuAnVKT.map((e, i) => (
                        <Select.Option
                          value={e.Tendoan}
                          idquan={e.IDHuyen}
                          idphuong={e.Maphuong}
                          key={i}
                        >
                          {e.Tendoan}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  type='primary'
                  className='button'
                  onClick={() => {
                    this.onResetButton();
                  }}
                >
                  Tìm mới
                </Button>
                <Button
                  type='primary'
                  className='button'
                  onClick={() => {
                    this.onSearch();
                  }}
                  disabled={
                    this.state.selectedQuan &&
                    this.state.selectedPhuong &&
                    this.state.selectedDuAn
                      ? false
                      : true
                  }
                >
                  Tìm kiếm
                </Button>
              </div>
            </div>
          </div>

          <div className='footer' style={{ position: 'unset' }}>
            <div style={{ display: 'flex' }}>
              <div className='required'>*</div>
              <div className='text'>Thông tin bắt buộc</div>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    listQuan: state.search.listQuan,
    listPhuong: state.search.listPhuong,
    listDuAnVKT: state.search.listDuAnVKT,
  };
};

const mapDispatchToProps = {
  getDataQuan: getDataQuan,
  getDataPhuong: getDataPhuong,
  getDataDuAnVKT: getDataDuAnVKT,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchKienTruc);
